<template>
    <li
        class="menu-item"
        :class="`${checkDropdown ? 'active' : ''} ${
            selected ? 'selected' : ''
        }`"
    >
        <a href="javascript:;" class="menu-link" @click="handleClick">
            <inline-svg
                :name="`map/${item.icon}`"
                width="15"
                height="15"
                classes="menu-link__icon"
            ></inline-svg>
            <span class="menu-link__text">{{
                `map.${item.name}` | trans
            }}</span>
            <div v-if="item.tooltip" class="tooltip-container">
                <inline-svg
                    name="map/info"
                    width="12"
                    height="12"
                    classes="info-tooltip"
                    v-if="item.calculation"
                ></inline-svg>
            </div>
            <inline-svg
                name="map/down-arrow"
                width="10"
                height="10"
                :classes="`menu-link__dropdown ${selected ? 'selected' : ''}`"
                v-if="(submenuItems && submenuItems.length) || item.calculation"
            ></inline-svg>
        </a>
        <toll-calculation
            v-if="item.calculation && this.tollStations.length && active"
            :urlKey="item.urlKey"
            v-show="active"
        ></toll-calculation>

        <sub-menu
            v-if="submenuItems && submenuItems.length"
            v-show="active"
            :items="submenuItems"
            :parent="item"
            :active="active"
        />
    </li>
</template>
<script>
import SubMenu from "./SubMenu.vue";
import inlineSvg from "./inlineSvg.js";
import TollCalculation from "./TollCalculation.vue";
import tippy from "tippy.js";
import axios from "./axios.js";
import { mapGetters } from "vuex";

export default {
    name: "MenuItem",
    props: {
        item: {
            default: () => {},
        },
        getDropdown: {
            type: Function,
        },
    },
    components: {
        SubMenu,
        inlineSvg,
        TollCalculation,
    },
    data() {
        return {
            selected: false,
            requested: false,
            active: false,
        };
    },
    mounted() {
        if (this.item.tooltip) {
            tippy(".tooltip-container", {
                content: this.trans.get("map.toll_tooltip"),
            });
        }
    },
    methods: {
        handleClick() {
            //@TODO ad handler for type of item
            this.$store.commit("setModal", null);

            if (!this.checkFilters) {
                if (this.item.name === "toll_calculation") {
                    this.getTolls();
                } else if (this.item.dropdown) {
                    // show submenu
                    if (!this.submenuItems.length) {
                        this.getDropdown();
                    }
                } else {
                    // show single menu item markers
                    let payload = { ...this.item, category: this.item.name };
                    this.$store.commit("addFilter", payload);

                    if (!this.highwayFilters) {
                        this.getMarkers();
                    } else {
                        this.getHighwayMarkers();
                    }
                }
            } else {
                let payload = { ...this.item, category: this.item.name };
                this.$store.commit("removeFilter", payload);
                this.$store.commit("removeMarkers", payload);
            }

            this.active = !this.active;
        },

        getTolls() {
            if (!this.tollStations.length) {
                let url = `${this.url}/toll-places`;
                axios
                    .get(url)
                    .then((res) => {
                        this.$store.commit("setTollStations", res.data);
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        },

        getMarkers() {
            this.$store.commit("setModal", null);
            let url = `${this.url}/${this.item.urlKey}`;
            axios
                .get(url)
                .then((res) => {
                    let data = res.data,
                        response = {
                            category: this.item.name,
                            data: data,
                        };
                    this.$store.commit("setMarkers", response);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        getHighwayMarkers() {
            this.$store.commit("setModal", null);
            let url = this.url;
            let params = {};

            Object.keys(this.filters).forEach((filter) => {
                if (filter === "tollPlacesType") {
                    params["tollPlaces"] = 1;
                } else {
                    params[filter] = this.filters[filter];
                }
            });

            axios
                .get(url, { params })
                .then((res) => {
                    this.$store.commit("setHighwayMarkers", res.data);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
    },

    computed: {
        ...mapGetters([
            "highways",
            "filters",
            "restAreas",
            "url",
            "objects",
            "codebook",
            "highwayFilters",
            "tollPlacesType",
            "tollStations",
        ]),

        submenuItems() {
            if (this[this.item.name]) {
                return this[this.item.name].map((el) => {
                    if (this.item.name === "highways") {
                        return {
                            ...el,
                            category: this.item.name,
                            paramKey: this.item.paramKey,
                        };
                    } else {
                        return {
                            name: this.trans.get(`map.${el}`),
                            category: this.item.name,
                            paramKey: this.item.paramKey,
                            id: el,
                        };
                    }
                });
            } else return [];
        },

        checkFilters() {
            if (this.filters && this.filters[this.item.name]) {
                if (typeof this.filters[this.item.name] == "object") {
                    return !!this.filters[this.item.name].find(
                        (el) => el === this.item.id
                    );
                }
                return true;
            }
            return false;
        },

        checkDropdown() {
            if (this.item.dropdown && this.active) {
                return true;
            }
            return this.checkFilters;
        },
    },

    watch: {
        filters(newValue) {
            this.selected = !!Object.keys(newValue).find(
                (el) => el === this.item.name
            );
        },
    },
};
</script>
